import { Reducer } from 'redux'
import { FlyOutSyncsActionTypes } from './actions'
import { FlyOutListingUserType } from './types'

export { FlyOutListingUserType } from './types'

export interface AwsFlyoutSellerMetadata {
  awsRoleArn: string
  awsCasS3BucketName: string
  awsCasSnsTopic: string
  awsKmsKeyArn?: string
}

export interface FlyOutListingData {
  origin: FlyOutListingUserType
  sellerMetadata: AwsFlyoutSellerMetadata
  onboarded?: boolean
  awsAccountId?: string
  awsAccountName?: string
  currencies?: string[]
  // sellerType?: string
  sellerType?: string[]
  countryRegistered?: string
}
export const initialState = {
  onboarded: undefined,
  origin: '' as FlyOutListingUserType,
  sellerMetadata: {
    awsRoleArn: '',
    awsCasS3BucketName: '',
    awsCasSnsTopic: '',
    awsKmsKeyArn: '',
  } as AwsFlyoutSellerMetadata,
  awsAccountId: '',
  awsAccountName: '',
  currencies: [],
  sellerType: [],
}
type actionType = {
  type: FlyOutSyncsActionTypes.SET_FLYOUT_LISTING_DATA
  payload: {
    onboarded: boolean
    origin: FlyOutListingUserType
    sellerMetadata: AwsFlyoutSellerMetadata
    awsAccountId?: string
    awsAccountName?: string
    currencies?: string[]
    sellerType?: string[]
    countryRegistered?: string
  }
}

export const reducer: Reducer<FlyOutListingData, actionType> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case FlyOutSyncsActionTypes.SET_FLYOUT_LISTING_DATA: {
      return {
        ...state,
        origin: action.payload.origin,
        sellerMetadata: action.payload?.sellerMetadata,
        onboarded: action.payload?.onboarded,
        awsAccountId: action.payload?.awsAccountId,
        awsAccountName: action.payload?.awsAccountName,
        // Only update currencies if it's provided in the payload
        ...(action.payload?.currencies !== undefined && {
          currencies: action.payload.currencies,
        }),
        // Only update sellerType if it's provided in the payload
        ...(action.payload?.sellerType !== undefined && {
          sellerType: action.payload.sellerType,
        }),
        countryRegistered: action.payload?.countryRegistered,
      }
    }
    default: {
      return state
    }
  }
}

export interface MicrosoftFlyOutListingData {
  origin: FlyOutListingUserType
  onboarded?: boolean
  currencies?: string[]
  sellerName?: string
}
export const initialStateMicrosoft = {
  onboarded: undefined,
  origin: '' as FlyOutListingUserType,
  currencies: [],
}
type actionTypeMicrosoft = {
  type: FlyOutSyncsActionTypes.SET_FLYOUT_LISTING_DATA_MICROSOFT
  payload: {
    onboarded: boolean
    origin: FlyOutListingUserType
    currencies?: string[]
    sellerName?: string
  }
}

export const reducerMicrosoft: Reducer<
  MicrosoftFlyOutListingData,
  actionTypeMicrosoft
> = (state = initialStateMicrosoft, action) => {
  switch (action.type) {
    case FlyOutSyncsActionTypes.SET_FLYOUT_LISTING_DATA_MICROSOFT: {
      return {
        ...state,
        origin: action.payload.origin,
        onboarded: action.payload?.onboarded,
        // Only update currencies if it's provided in the payload
        ...(action.payload?.currencies !== undefined && {
          currencies: action.payload.currencies,
        }),
        ...(action.payload?.sellerName !== undefined && {
          sellerName: action.payload.sellerName,
        }),
      }
    }
    default: {
      return state
    }
  }
}
